import axios from 'axios';
import { Chain, CustomerProfile } from './models';
export default {
	/**
	 * Get previous visited chains for current user.
	 * @param {Number} [tpnChainId=0] - If TPN, pass in the current chainId to filter.
	 * @returns {Promise<Chain[]|Boolean>} Array of chains, or `false` if request failed.
	 */
	async GetPreviousVisitedChains(tpnChainId = 0) {
		const result = await axios.post('/api/ajax/ChainApi/GetPreviousVisitedChains', { tpnChainId });
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.Chains.map(chain => new Chain(chain));

			default:
				return false;
		}
	},

	/**
	 * Get registered customer profiles for current logged in user and chainId.
	 * @param {Number} chainId - The chainId to get customer profiles from.
	 * @returns {Promise<CustomerProfile[]|Boolean>} Array of customer profiles, or `false` if request failed.
	 */
	async GetCustomerProfiles(chainId = 0) {
		const result = await axios.post('/api/ajax/CustomerProfileApi/GetCustomerProfiles', { ChainId: chainId });
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.Customers.map(customer => new CustomerProfile(customer));

			case 204:
				return [];

			default:
				return false;
		}
	},

	/**
	 * Update and set customer profile.
	 * @param {CustomerProfile} customerProfile - The updated customer profile to set.
	 */
	async SetCustomerProfile(customerProfile = new CustomerProfile()) {
		const result = await axios.post('/api/ajax/CustomerProfileApi/UpdateCustomer', customerProfile);
		switch (Object(result.data).ResponseCode) {
			case 202:
				return new CustomerProfile(result.data.Customer);

			default:
				return false;
		}
	},

	/**
	 * Update and set booking profile as current profile for provided mobile number and chainId.
	 * @param {CustomerProfile} customerProfile - The customer profile to update.
	 */
	async SetBookingProfile(customerProfile = new CustomerProfile()) {
		const result = await axios.post('/api/ajax/CustomerProfileApi/SetBookingProfileForMobileNumberByChain', {
			ChainId: customerProfile.chainId,
			CustomerId: customerProfile.customerId,
			MobileNumber: customerProfile.mobilePhoneNumber
		});
		switch (Object(result.data).ResponseCode) {
			case 202:
				return true;

			default:
				return false;
		}
	}
};
